
interface StarIconProps {
  filled: boolean;
}

/**
 * Star icon component used for favoriting/starring items.
 * Displays filled or outlined star based on the filled prop.
 */
export function StarIcon({ filled }: StarIconProps) {
  if (filled) {
    return (
      <svg className="w-3.5 h-3.5" viewBox="0 0 16 16" fill="var(--color-lemon-700)">
        <path d="M8 0l2.47 5.01L16 5.82l-4 3.9.94 5.48L8 12.68l-4.94 2.52.94-5.48-4-3.9 5.53-.81L8 0z" />
      </svg>
    );
  }
  return (
    <svg className="w-3.5 h-3.5 text-icon-subtle hover:text-lemon-400 transition-colors" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M8 1l2.09 4.23 4.67.68-3.38 3.29.8 4.65L8 11.68l-4.18 2.17.8-4.65L1.24 5.91l4.67-.68L8 1z" />
    </svg>
  );
}
